module.exports = __webpack_public_path__ + "img/web.cc03bdc9.svg";